const permissions = require('../../src/js/client/Permissions');

exports._openAppSettings = permissions.openAppSettings;
exports._checkCameraPermission = permissions.checkCameraPermission;
exports._requestCameraPermission = permissions.requestCameraPermission;
